import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  isDownloadInProgress: false,
  totalFilesToDownload: 0,
  countOfDownloadSuccess: 0,
  countOfDownloadFailed: 0,
  failDownloadFiles: []
};

const FileDownloadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_STARTED:
      return { ...state, isDownloadInProgress: true };
    case actionTypes.DOWNLOAD_COMPLETED:
      return { ...state, isDownloadInProgress: false };
    case actionTypes.SET_TOTAL_FOR_DOWNLOAD:
      return { ...state, totalFilesToDownload: action.data };
    case actionTypes.INCREASE_DOWNLOAD_SUCCESS_COUNT:
      return { ...state, countOfDownloadSuccess: state.countOfDownloadSuccess + 1 };
    case actionTypes.INCREASE_DOWNLOAD_FAILED_COUNT:
      return { ...state, countOfDownloadFailed: state.countOfDownloadFailed + 1 };
    case actionTypes.RESET_DOWNLOAD_STATE:
      return { ...state, isDownloadInProgress: false, totalFilesToDownload: 0, countOfDownloadSuccess: 0 , failDownloadFiles: [], countOfDownloadFailed: 0};
    case actionTypes.RESET_DOWNLOAD_STATE_WITH_FAILURES:
      return { ...state, isDownloadInProgress: false, totalFilesToDownload: 0, countOfDownloadSuccess: 0 };
    case actionTypes.ADD_FAILED_DOWNLOAD_FILE:
      return {...state,failDownloadFiles: [...state.failDownloadFiles, action.data]};
    default:
      return state;
  }
};

export default FileDownloadReducer;